import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppAvailability } from '@ionic-native/app-availability/ngx';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { WebIntent } from '@ionic-native/web-intent/ngx';
import { Platform } from '@ionic/angular';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PaymentService } from '../payment.service';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
})
export class DemoComponent  {
  contactNbrMob;
  customerInvoiceId;
  requestorId;
  payTotal;
  CALLBACK_URL;
  CHECKSUMHASH;
  purrchaseItems:any;
  TXN_AMOUNT;
  type;
  MID;
  mobile;
  cost;
url;
email;
subs:boolean=false;
paynow:boolean=true;
value;
appBrowser;browsewindow;  RazorpayCheckout:any;
  constructor(private router:Router, private browser: InAppBrowser,private service: ApiService,public handler: HandlerService, public payment:PaymentService,private appAvailability: AppAvailability,private platform: Platform,
    private intent:WebIntent,  private splash: SplashScreen) { }
  id;loader:boolean=false;

  checkForSucess(dur) {
    let obj = this
    setTimeout(() => {
      this.appBrowser.executeScript({ code: "localStorage.getItem('success')" }, function (values) {
        if (values[0] =='true'){
          setTimeout(() => {
            obj.appBrowser.close();
          }, 5000);
        }
        else
          obj.checkForSucess(2000)
      })
    }, dur);
  }

  routeback(){
    this.router.navigateByUrl('bookservice1')
  }

  checkBrowserUrl(dur){
   setTimeout(() => {
    if(this.browsewindow.location.href.includes("invoices/confirmPayment")){
   if(this.browsewindow.localStorage.success){
     setTimeout(() => {
      this.browsewindow.close();
      this.routeback()
      }, 5000);
    }
   }
    else
    this.checkBrowserUrl(2000)
   }, dur);
  }

  

  start() {
          let x={
          CALLBACK_URL: this. CALLBACK_URL,
CHANNEL_ID: "WAP",
CHECKSUMHASH: this.CHECKSUMHASH,
CUST_ID: this.requestorId,
EMAIL: this.email,
INDUSTRY_TYPE_ID: "Retail",
MID: this.MID,
MOBILE_NO: '+91'+this.mobile,
ORDER_ID: this.id,
TXN_AMOUNT: this.TXN_AMOUNT,
WEBSITE: "WEBSTAGING",

        }
        console.log(x)
        sessionStorage.setItem('paydata', JSON.stringify(x));
        setTimeout(() => {
          if (this.platform.is('android')) {
            this.splash.hide()
            const options: InAppBrowserOptions = {
              location: "yes",
              hideurlbar: 'yes',
              closebuttoncaption: "Close",
              hidenavigationbuttons: "yes",
              hardwareback: 'no'
            }
            var pageContent = '<html>' +
              '<head>' +
              '<title>Merchant Check Out Page</title>' +
              '<body>' +
              '<centre><h1>Please do not refresh this page...</h1></centre>' +
              '<form method="post" action="'+'https://securegw-stage.paytm.in/order/process'+'" name="paytm">' +
              '<table border="1">' +
              ' <tbody>' +
              '<input type="hidden" id="mid" name="MID" value="' + this.MID + '">' +
              '<input type="hidden"  name="WEBSITE" value="' + 'WEBSTAGING' + '">' +
              '<input type="hidden" name="ORDER_ID" value="' + this.id + '">' +
              '<input type="hidden" name="CUST_ID" value="' + this.requestorId + '">' +
              '<input type="hidden" name="MOBILE_NO" value="' + x.MOBILE_NO + '">' +
              '<input type="hidden" name="EMAIL" value="' + this.email+ '">' +
              '<input type="hidden" name="INDUSTRY_TYPE_ID" value="' + 'Retail' + '">' +
              '<input type="hidden" name="CHANNEL_ID"value="' + 'WAP' + '">' +
              '<input type="hidden" name="TXN_AMOUNT"value="' + this.TXN_AMOUNT + '">' +
              '<input type="hidden" name="CALLBACK_URL"value="' + this.CALLBACK_URL + '">' +
              '<input type="hidden" id="checksum" name="CHECKSUMHASH"value="' + this.CHECKSUMHASH + '">' +
              '</tbody>' +
              '</table>' +
              ' <script type="text/javascript">' +
              'setTimeout(() => {' +
              'document.paytm.submit()' +
              '}, 5000);' +
              '</script>' +
              '</form>' +
              '</body></head></html>'
            var pageContentUrl = 'data:text/html;base64,' + btoa(pageContent);
            this.appBrowser = this.browser.create(pageContentUrl, '_blank', options);
            this.appBrowser.on('exit').subscribe(res => {
              this.router.navigateByUrl('bookservice1')
            })
            this.appBrowser.on('loadstop').subscribe(res => {
              if (res.url.includes('confirmPayment')) {
                this.checkForSucess(2000)
              }
            })
          }
          else {
           this.browsewindow= window.open('assets/paytm.html','_blank', 'height=screen.height,width=screen.width')
           this.checkBrowserUrl(5000)
          }
        })
    
   
  }

}
